<template>
  <div class="menu-item" @click="toggleMenu" @mouseleave="closeMenu">
    <label>
      Suporte
      <i class="fas fa-info-circle custom-arrow-icon" aria-hidden="true"></i>
    </label>
    <transition name="fade" appear>
      <!-- MODIF: Adicionado ref ao submenu -->
      <div class="sub-menu" v-if="isOpen" ref="submenu">
        <!-- MODIF: Alterado o item "Manual de Utilização" para ser clicável em toda a área -->
        <a href="/PED_Manual_Uso_Acesso_Dados_v1_4.pdf" target="_blank" class="menu-item nav-item nav-link" id="ajuda">
          Manual de Utilização
        </a>
        <!-- MODIF: Alterado para router-link custom para que o div inteiro seja clicável -->
        <router-link to="/suporte/faq" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="faq">
            FAQ
          </div>
        </router-link>
        <router-link to="/suporte/termouso" custom v-slot="{ navigate, isActive }">
          <div @click="navigate" :class="['menu-item', 'nav-item', 'nav-link', { active: isActive }]" id="termouso">
            Termos de Uso
          </div>
        </router-link>
      </div>
    </transition>
  </div>
</template>

<script>
import "@fortawesome/fontawesome-free/css/all.css";
export default {
  name: "services",
  props: ["title"],
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        this.$nextTick(() => {
          this.adjustSubmenuPosition();
        });
      }
    },
    closeMenu() {
      this.isOpen = false;
    },
    adjustSubmenuPosition() {
      const submenu = this.$refs.submenu;
      if (submenu) {
        const rect = submenu.getBoundingClientRect();
        if (rect.right > window.innerWidth) {
          submenu.style.left = "auto";
          submenu.style.right = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else if (rect.left < 0) {
          submenu.style.left = "0";
          submenu.style.transform = "none"; // MODIF: Ajustado para caber na tela
        } else {
          submenu.style.left = "50%";
          submenu.style.right = "auto";
          submenu.style.transform = "translateX(-50%)";
        }
      }
    },
  },
};
</script>

<style>
nav .menu-item svg {
  width: 10px;
  margin-left: 10px;
}
nav .menu-item .sub-menu {
  position: absolute;
  background-color: #3276b1; /* MODIF: Fundo opaco garantido */
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  border-radius: 0px 0px 16px 16px;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.2s ease-out;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.sub-menu {
  cursor: pointer;
}
</style>

